import BallotIcon from '@material-ui/icons/Ballot';
import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import eventsAPI, { Event, LeadMentorReportData } from '../../api/events';
import { getRoutePath, Pages } from '../../router/constants';
import PopupIcon from '../common/popup-icon';

interface LeadMentorReportIconProps {
  session: Event;
}

function LeadMentorReportIcon({ session }: LeadMentorReportIconProps) {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [leadMentorReport, setLeadMentorReport] =
    useState<LeadMentorReportData | null>(null);

  const fetchFounderNotesReport = useCallback(async () => {
    try {
      if (!session.leadMentorReportId) {
        return;
      }

      setIsLoading(true);
      const lastLeadMentorReport = await eventsAPI.getLeadMentorReportLast(
        session.id,
      );
      setLeadMentorReport(lastLeadMentorReport);
    } catch (e) {
      console.error(e);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [session.leadMentorReportId, session.id]);

  return (
    <PopupIcon
      to={{
        pathname: getRoutePath(Pages.SESSIONS_REPORT, {
          sessionId: session.id,
        }),
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      }}
      icon={<BallotIcon />}
      testId='lead-mentor-report-icon'
      content={leadMentorReport?.contents}
      emptyText='The report is not submitted.'
      errorText='Something went wrong... Please try again later.'
      isNoIcon={!session.leadMentorReportId}
      isLoading={isLoading}
      isError={isError}
      onHover={fetchFounderNotesReport}
    />
  );
}

export default LeadMentorReportIcon;
